import styles from './status-chip.module.scss';

export const StatusChip = ({ label, type = '' }) => {
  return (
    <span className={styles['chip']} data-type={type}>
      {label}
    </span>
  );
};
